import { render, staticRenderFns } from "./SingleSwitch.vue?vue&type=template&id=4b49ed6e"
import script from "./SingleSwitch.vue?vue&type=script&lang=js"
export * from "./SingleSwitch.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports